import { FrontierService } from '@api';
import { useState } from 'react';
import { useAppQuery } from '@api/query/use-app-query';
import { InventoryQueryKeys } from '@Inventory/services/queryKeys';
import { InventoryFilterInput, PaginationInput } from '@api/gql/graphql';
import { inventoryResourcesQueryDocument } from '@Inventory/services/gql';

export function useInventoryResources(filter?: InventoryFilterInput, pagination?: PaginationInput) {
  const [isFirstTimeFetched, setIsFirstTimeFetched] = useState(false);

  const fetch = async () => {
    const res = await FrontierService.request(inventoryResourcesQueryDocument, {
      filter,
      pagination,
    });
    setIsFirstTimeFetched(true);
    return {
      data: res.inventoryResources.edges,
      hasMore: res.inventoryResources.hasMore,
    };
  };

  const res = useAppQuery([InventoryQueryKeys.InventoryResources, JSON.stringify({ filter, pagination })], fetch, {
    keepPreviousData: true,
  });

  return {
    ...res,
    isFetched: isFirstTimeFetched,
  };
}
